function PlanCtrl($scope,$timeout,$state,DateTimeService, AccountItemService, GeneralUtilsService, UserContextService, ExportVpnUsersService){
    var MAX_YEAR_MOD_FROM_NOW = 15;  // the now + years to allow as selection in the date picker for the expiration
    $scope.lastTrialAmount = null;   // saving temp var when going back and forth from Trial to Commercial
    $scope.planStats = {};

    $scope.Math = Math;

    $scope.loadedUsage = false;

    $scope.malwareProtectionService = {
        name : "Malware Protection",
        id : "malwareProtection",

        isEnabled: function() {
            return $scope.plan.malwareProtection;
        },

        setEnabled: function(enabled) {
            $scope.plan.malwareProtection = enabled;
        },

        getLifeCycle: function() {
            return $scope.plan.malwareProtectionLifeCycle;
        },

        setLifeCycle: function(lifeCycle) {
            $scope.plan.malwareProtectionLifeCycle = lifeCycle;
        },

        getExpiration: function() {
            return $scope.plan.malwareProtectionExpiration;
        },

        setExpiration: function(expiration) {
            $scope.plan.malwareProtectionExpiration = expiration;
        }
    };

    $scope.ngMalwareProtectionService = {
        name : "NG Malware Protection",
        id : "ngMalwareProtection",

        isEnabled: function() {
            return $scope.plan.malwareProtection && $scope.plan.ngMalwareProtection;
        },

        setEnabled: function(enabled) {
            $scope.plan.ngMalwareProtection = enabled;
        },

        getLifeCycle: function() {
            return $scope.plan.ngMalwareProtectionLifeCycle;
        },

        setLifeCycle: function(lifeCycle) {
            $scope.plan.ngMalwareProtectionLifeCycle = lifeCycle;
        },

        getExpiration: function() {
            return $scope.plan.ngMalwareProtectionExpiration;
        },

        setExpiration: function(expiration) {
            $scope.plan.ngMalwareProtectionExpiration = expiration;
        }
    };

    $scope.casbService = {
        name : "CASB",
        id : "casb",

        isEnabled: function() {
            return $scope.plan.casb;
        },

        setEnabled: function(enabled) {
            $scope.plan.casb = enabled;
        },

        getLifeCycle: function() {
            return $scope.plan.casbLifeCycle;
        },

        setLifeCycle: function(lifeCycle) {
            $scope.plan.casbLifeCycle = lifeCycle;
        },

        getExpiration: function() {
            return $scope.plan.casbExpiration;
        },

        setExpiration: function(expiration) {
            $scope.plan.casbExpiration = expiration;
        }
    };


    $scope.ipsService = {
        name : "IPS",
        id : "ips",

        isEnabled: function() {
            return $scope.plan.ips;
        },

        setEnabled: function(enabled) {
            $scope.plan.ips = enabled;
        },

        getLifeCycle: function() {
            return $scope.plan.ipsLifeCycle;
        },

        setLifeCycle: function(lifeCycle) {
            $scope.plan.ipsLifeCycle = lifeCycle;
        },

        getExpiration: function() {
            return $scope.plan.ipsExpiration;
        },

        setExpiration: function(expiration) {
            $scope.plan.ipsExpiration = expiration;
        }
    };

    $scope.generalService = {
        id: 'general',

        getExpiration: function() {
            return $scope.plan.currentLifeCycleExpiration;
        },

        setExpiration: function(expiration) {
            $scope.plan.currentLifeCycleExpiration = expiration;
        }
    };

    //startup
    $scope.lifecycledatamodified = false;
    $scope.siteUsagedatamodified = false;
    $scope.userUsagedatamodified = false;
    $scope.lastLifeCycle = null;
    $scope.datepickerOptions = {};


    var maxDate = new Date();
    maxDate.setYear(maxDate.getFullYear() + MAX_YEAR_MOD_FROM_NOW);
    var minDate = new Date();
    $scope.datePickerOptions = {
        minDate: minDate,
        maxDate: maxDate,
    };

    if(UserContextService.isSystemLogin()){
       $scope.isSystemLogin = true;
    }

    //populate possible life cycles
   	$scope.loadLifeCycleList = function(){
    	store.fetch({
            path: "lifeCycles",
    		success: function(data) {
                $timeout(function(){
                    $scope.lifeCycleLists = [];
                    data.items.forEach(function(lifeCycle) {
                        if(lifeCycle.name!== 'Scheduled'){
                            $scope.lifeCycleLists.push(lifeCycle.name);
                        }
                    });
                }, 0);
    		}
    	});
    };
    $scope.loadLifeCycleList();

    //populate possible Dpa versions
    $scope.loadDpaVersionList = function(){
        store.fetch({
            path: "dpaVersions",
            success: function(data) {
                $timeout(function(){
                    $scope.dpaVersions = [];
                    data.items.forEach(function(dpaVersion) {
                        $scope.dpaVersions.push(dpaVersion.name);
                    });
                }, 0);
            }
        });
    };
    $scope.loadDpaVersionList();

    //populate zones for site
    $scope.loadSiteZonesList = function(){
    	store.fetch({
            path: "siteZones",
    		success: function(data) {
                $timeout(function() {
                    $scope.siteZonesMap = data;
                    $scope.siteZonesList = [];
                    for (var key in $scope.siteZonesMap) {
                        $scope.siteZonesList.push(key);
                    }
                    $scope.userUsageConfig.siteZonesList = $scope.siteZonesList;
                }, 0);
    		}
    	});
    };
    $scope.loadSiteZonesList();

    //populate zones for user
    $scope.loadUserZonesList = function(){
    	store.fetch({
            path: "userZones",
    		success: function(data) {
                $timeout(function() {
                    $scope.userZonesList = data;
                    $scope.userUsageConfig.userZonesList = $scope.userZonesList;
                }, 0);
    		}
    	});
    };
    $scope.loadUserZonesList();

    //populate plan default settings
    $scope.loadPlanDefaultSettings = function(){
        store.fetch({
            method: 'GET',
            path: 'getPlanDefaults',
            success: function(data) {
                $scope.planDefaultSettings = data;
                if ($scope.plan){
                    $scope.userUsagedatamodified = new Date().getTime();
                }
                $scope.$digest();
            }
        });
    };
    $scope.loadPlanDefaultSettings();


    //get plan data
	store.fetch({
        path: "/getPlan",
        queryParams: {'accountId': $state.params.accountId},
        success: function(data) {
            $timeout(function() {
                $scope.presentedSettings = {}
                $scope.plan = data;
                $scope.orig = angular.copy($scope.plan);
                // saving the configured maxAccessLogin for Trial if needed to rollback
                if (data.currentLifeCycle === "Trial"){
                    if(data.accessLoginUsage && data.accessLoginUsage.length > 0){
                        $scope.lastTrialAmount = data.accessLoginUsage[0].maxAccessLogin;
                    }
                }

                updatePresentedSettings();

                $scope.userUsageConfig.items = angular.copy(data.accessLoginUsage);
                $scope.userUsageOrigItems = angular.copy(data.accessLoginUsage);
                getSiteUsageStats();
                $scope.lifecycledatamodified = new Date().getTime();
                populateSiteUsageConfiguration();
            }, 0);
        }
    });

	function populateSiteUsageConfiguration() {
        $scope.siteUsageComponentConfig = {
            planId: $scope.plan.id,
            autoPopulate: false,
            plan: $scope.plan,
            planStats: $scope.planStats,
            isValid: function () {
                return true;
            },
            // default implementation will be overriden by the plan-site-usage component
            getSiteUsageConfig: function (currentSiteUsage) {
                /*if(currentSiteUsage == 'Lock'){
                    return $scope.orig.siteUsage;
                }
                else{
                    return [];
                }*/
                return $scope.orig.siteUsage;
            },
            reload: function () {
            },
            isSystemLogin: $scope.isSystemLogin,
            datePickerOptions: $scope.datePickerOptions
        };
    }

    $scope.exportToCsv = function () {
						ExportVpnUsersService.exportToCsv($state.params.accountId, function (data) {
										$scope.$broadcast('stop-load');
										$scope.handleServerResponse(data, "", "");
						});
				}

    //identify changes in model for save
    $scope.$root.hasChanges = function(){
	    // wouldn't like to allow saving if not valid
	    if(!isValid())
	        return false;

        var plan = $scope.plan;
        if(!plan) return false;
        if(plan.id < 0) return true; //new domain
        if(!angular.equals($scope.plan, $scope.orig)) return true;
        if ($scope.plan.dpaVersion == 'DPA_2021_01') {
            if(!angular.equals($scope.presentedSettings.dataRetentionPeriod, $scope.plan.dataRetentionPeriod)) return true;
        }
        if(!angular.equals($scope.userUsageConfig.items, $scope.userUsageOrigItems)) return true;
        if($scope.siteUsageComponentConfig && $scope.siteUsageComponentConfig.hasChanges && $scope.siteUsageComponentConfig.hasChanges()) return true;
        if ($scope.plan.currentLifeCycleExpiration !== $scope.orig.currentLifeCycleExpiration) return true;
        return false;
   };

    //save model
    $scope.saveChanges = function(callBack){
        var path;
        var params;
        if($scope.plan.id){
           path = "/edit";
           params = {'planId':$scope.plan.id,'save':true,'accountId': $state.params.accountId}
        }else {  //new item
          path = "/add";
          params = {'accountId': $state.params.accountId,'type':'Plan.Plan','save':true}
        }

        //update itemsToDelete
        $scope.updateItemsToDelete();

        //insert chosen data retention period to plan to be saved
        if ($scope.plan.dpaVersion == 'DPA_2021_01') {
            if(!angular.equals($scope.presentedSettings.dataRetentionPeriod, $scope.plan.dataRetentionPeriod)) {
                $scope.plan.dataRetentionPeriod = $scope.presentedSettings.dataRetentionPeriod;
            }
        }

        $scope.plan.siteUsage = $scope.siteUsageComponentConfig.getSiteUsageConfig($scope.plan.currentLifeCycle);

        $scope.plan.accessLoginUsage = angular.copy($scope.userUsageConfig.items);

        //if site is still Unassigned - send as null --> we only tampare with the site usage if it wasn't in lock
        if($scope.plan.siteUsage && $scope.plan.currentLifeCycle!= 'Lock'){
            $scope.plan.siteUsage.forEach(function(item){
                if(item.site){
                    item.siteId = item.site.id;
                    delete item.site;
                }
            });
        }

        // if we're not changing to commercial, dont f*ck with usage limitation
        if ($scope.plan.currentLifeCycle != 'Commercial') {
            $scope.planStats.siteUsage = $scope.orig.siteUsage;
            $scope.planStats.siteTotal = $scope.orig.siteTotal;
            $scope.planStats.accessLoginTotal = $scope.orig.accessLoginTotal;
            $scope.planStats.accessLoginConfigured = $scope.orig.accessLoginConfigured;
        }

        $scope.plan.newSaveMethod = true;
        $scope.loading = true;
		store.save({
            path: path,
            data: $scope.plan,
            dataObj: 'json',
            queryParams:params ,
            success: function(data) {
                $timeout(function() {
                    $scope.loading = false;
                }, 0);
                $scope.$root.handleServerResponse(data,"plan", 'Plan saved successfully');
                if(data.status != "ERROR"){
                    delete $scope.$root.errors['licenseTableErrors'];
                    delete $scope.$root.errors['vpnUsersLicenseTableErrors'];
                    $scope.plan = data.model;
                    $scope.orig = angular.copy($scope.plan);
                    updatePresentedSettings();
                    $scope.userUsageOrigItems = angular.copy(data.model.accessLoginUsage);
                    $scope.userUsageConfig.items = angular.copy(data.model.accessLoginUsage);
                    getSiteUsageStats();
                    $scope.lifecycledatamodified = new Date().getTime();
                    $scope.siteUsageComponentConfig.reload();
                    $scope.siteUsagedatamodified = new Date().getTime();
                    $scope.userUsagedatamodified = new Date().getTime();
                    if(callBack){
                        callBack();
                    }
                    $scope.$digest();
                }
            }
	    });
    };

    function updatePresentedSettings() {
        if ($scope.plan.dpaVersion == 'DPA_2019_01') {
            $scope.presentedSettings.dataRetentionPeriod = $scope.planDefaultSettings ? $scope.planDefaultSettings.defaultDataRetentionPeriod : 6;
            $scope.presentedSettings.dataRetentionPeriodEffectiveFrom = DateTimeService.getDateInUTC(new Date());
        } else {
            $scope.presentedSettings.dataRetentionPeriod = $scope.plan.dataRetentionPeriod;
            $scope.presentedSettings.dataRetentionPeriodEffectiveFrom = $scope.plan.dataRetentionPeriodEffectiveFrom;
        }
    }

    function isValid() {
        var isValid = true;
        if($scope.siteUsageComponentConfig && $scope.siteUsageComponentConfig.isValid){
            isValid = $scope.siteUsageComponentConfig.isValid();
        }
        return isValid;
    }

    $scope.lifecycleConfig = {
        dataURL : function(){
            if(!$scope.plan.id){
                return null;
            }
            else {
            	return "/planLifeCycles?planId=" + $scope.plan.id;
            }
        },
        sortList: [{sortField: "lastTimestamp", sortDir: "DESC" }],
        items:[],
        fields : [
             {"label":"Type","path":"lifeCycleType","template":"<span>{{item.lifeCycleType}}</span>"},
             {"label":"Status","path":"lifeCycleStatus","template":"<span>{{item.lifeCycleStatus | camelCaseToHuman}}</span>"},
             {"label":"Modified on","path":"lastTimestamp","template":"<span>{{item.lastTimestamp | date:'short'}}</span>"},
             {"label":"Modifier","path":"modifier","template":"<span>{{item.modifier}}</span>"},
             {"label":"Modifier Email","path":"modifierAdmin","template":"<span>{{item.modifierEmail}}</span>","hideColumn":!isSystemLogin}

        ],
        type : "Plan",
        selectedItems:[],
        pageSize:10,
        defer:true,
        hideCheckboxes: true,
        customButtons : [],
        noSearch:true,
        isSystemLogin: $scope.isSystemLogin
    };

    var userUsageSpecialActions = [];

    if ($scope.isSystemLogin){
        var siteUsageAddAction = function(){
            $scope.newSiteUsage = {id:GeneralUtilsService.getRandomId(),"name":"", siteId : -1, site : $scope.siteUsageConfig.sites[0], region : $scope.siteZonesList[0], quantity: 1};
            $scope.$root.openPopup('addSiteUsageDlg');
        };

        var userUsageAddAction =  function(){
            $scope.newUserUsage = {id:GeneralUtilsService.getRandomId(),"name":"",region : $scope.userZonesList[0]};
            $scope.$root.openPopup('addUserUsageDlg');
        };


        userUsageSpecialActions.push(
            {"func":function(selectedItems) {
                let deletedItems = [];
                selectedItems.forEach(function(item) {
                    for(var i = 0 ; i < $scope.userUsageConfig.items.length ; i++){
                        var userUsage = $scope.userUsageConfig.items[i];
                        if(userUsage.id === item.id){
                            $scope.userUsageConfig.items.splice(i,1);
                            $scope.planStats.accessLoginTotal-= userUsage.maxAccessLogin;
                            if(userUsage.id > 0){
                                deletedItems.push(item);
                            }
                            break;
                        }
                    }
                });
                $scope.plan.itemsToDelete.accessLoginUsage = ($scope.plan.itemsToDelete.accessLoginUsage && $scope.plan.itemsToDelete.accessLoginUsage.length > 0) ?
                                                              deletedItems.concat($scope.plan.itemsToDelete.accessLoginUsage) :
                                                              deletedItems;
            },"icon":"delete",tooltip:"Delete"}
        );
    }

    $scope.updateItemsToDelete = function() {
        // had to add AllowIndirectRemovals annotation (cascade problem) - but when this annotation is added delete of subItems are done according to comparing list
        // which mean deleting subItems from other pages, to avoid unwanted removals added a check if item is part of delete map - also if there are no deleted items
        if (!$scope.plan.itemsToDelete){
            $scope.plan.itemsToDelete = {};
        }
        $scope.plan.itemsToDelete.siteUsage = $scope.siteUsageComponentConfig.itemsToDelete;
        if (!$scope.plan.itemsToDelete.accessLoginUsage){
            $scope.plan.itemsToDelete.accessLoginUsage = [];
        }
    };



    $scope.userUsageConfig = {
        dataURL : function(){
            if(!$scope.plan.id){
                return null;
            }
            else {
                return "/planUserUsage?planId=" + $scope.plan.id;
            }
        },
        processData : function(items){
            var isChangedToTrial = false;
            items.forEach(function(item){
                item.lastModifiedTime = moment(GeneralUtilsService.getTimeInMiliseconds(item.lastModified)).calendar();
            });
            $scope.userUsageOrigItems = angular.copy(items);

            $scope.userUsageConfig.items.forEach(function(item){
                item.lastModifiedTime = moment(GeneralUtilsService.getTimeInMiliseconds(item.lastModified)).calendar();
            });
            if ($scope.plan.currentLifeCycle && $scope.plan.currentLifeCycle === 'Trial' && items.length === 1) {
                items[0].maxAccessLogin = $scope.planDefaultSettings.defaultMaxAccessLogin;
                isChangedToTrial = true;
            }
            $scope.planStats.accessLoginTotal = isChangedToTrial ? $scope.planDefaultSettings.defaultMaxAccessLogin : $scope.planStats.accessLoginTotal;
        },
        fields : [
            {"label":"Zone", "path":"region", "template":"<select ng-model='item.region' class='form-control' style='margin-top: 5%' ng-options='zone for zone in tableConfig.userZonesList' ng-disabled="+!$scope.isSystemLogin+"></select>"},
            {"label":"# Licensed Users", "path":"maxAccessLogin", "template":"<span><input type='text' ng-model='item.maxAccessLogin' ng-disabled="+!$scope.isSystemLogin+" /></span>"},
            {"label":"Modified on", "path":"lastTimestamp", "template":"<span>{{item.lastModifiedTime}}</span>"},
            {"label":"Modifier", "path":"modifier", "template":"<span>{{item.modifier}}</span>"}
        ],
        type : "AccessLoginUsageLimitation",
        selectedItems:[],
        pageSize:50,
        defer:true,
        hideCheckboxes: !$scope.isSystemLogin,
        customButtons : [],
        addAction : userUsageAddAction,
        actions: $scope.isSystemLogin ? [] : null,
        specialActions: userUsageSpecialActions,
        noSearch:true
    };

    $scope.addSiteUsage = function() {
        var sitesQuantity = 1;
        if ($scope.newSiteUsage.site.id == -1){
            sitesQuantity = $scope.newSiteUsage.quantity; //if its not an actual site (an Unassigned) use the quantity field
        }
        delete $scope.newSiteUsage.quantity;

        for (var i = 0; i < sitesQuantity; i++){
            var item = angular.copy($scope.newSiteUsage);
            if (sitesQuantity>1){
                item.id = GeneralUtilsService.getRandomId(); //creating new id to avoid duplication
            }
            item.expirationService = {
                id: 'item-' + item.site,
                getExpiration: function() {
                    return item.currentLifeCycleExpiration;
                },
                setExpiration: function(expiration) {
                    item.currentLifeCycleExpiration = expiration;
                }
            }
            $scope.siteUsageConfig.items.push(item);
            $scope.planStats.totalStats.total++;
            if (item.site){
                $scope.planStats.usedStats.total++;
            }
        }
        $scope.$root.closePopup('addSiteUsageDlg');
    };

    $scope.addUserUsage = function(){
        $scope.userUsageConfig.items.push($scope.newUserUsage);
        $scope.planStats.accessLoginTotal+= $scope.newUserUsage.maxAccessLogin;
        $scope.$root.closePopup('addUserUsageDlg');
    };

    $scope.setUnallocatedSite = function(item){
        if (item.siteId && item.siteId != -1){
            item.isAllocated = true;
        }
        else {
            for(let index in $scope.siteUsageConfig.sites){
            	var site = $scope.siteUsageConfig.sites[index];
                if(site.id == -1){
                    item.siteId = -1;
                    item.isAllocated = false;
                    item.site = site;
                    break;
                }
            }
        }
    };

    /**
     * update the services according to policy of switching between commercial
     * and trial on the account plan
     * @param value
     */
    function updateServices(value) {
        if($scope.item&& $scope.item.services){
            Object.keys($scope.item.services).forEach(function (serviceKey) {
                $scope.item.services[serviceKey] = value;
            });
        }
        if($scope.plan){
            $scope.plan.malwareProtection = value;
            $scope.plan.ngMalwareProtection = value;
            $scope.plan.ips = value;
            $scope.plan.casb = value;
        }
    }

	$scope.$watch('plan.currentLifeCycle', function(newValue, oldValue) {
		if (newValue && !_.isEqual(newValue,oldValue)) {
            $scope.siteUsageComponentConfig.autoPopulate = false;
		    $scope.lastLifeCycle = oldValue;

		    if (oldValue === 'Trial'){
		        if( $scope.userUsageConfig.items && $scope.userUsageConfig.items > 0){
		            $scope.lastTrialAmount = $scope.userUsageConfig.items[0].maxAccessLogin;
		        }
            }

		    if(newValue === 'Trial' && oldValue ){
		        if ($scope.userUsageConfig.items.length == 0){
		            $scope.userUsageConfig.items.push({ id:GeneralUtilsService.getRandomId(), "name":"", maxAccessLogin: $scope.planDefaultSettings.defaultMaxAccessLogin});
		            $scope.lastTrialAmount = $scope.planDefaultSettings.defaultMaxAccessLogin;
		        }

                if ($scope.lastTrialAmount){
                    $scope.planStats.accessLoginTotal = $scope.lastTrialAmount;
                    $scope.userUsageConfig.items[0].maxAccessLogin = $scope.lastTrialAmount;
                }else if ($scope.lastTrialAmount != null){
                    $scope.userUsageConfig.items[0].maxAccessLogin = $scope.lastTrialAmount;
                }else{
                    $scope.userUsageConfig.items[0].maxAccessLogin = Math.max($scope.planStats.accessLoginConfigured, $scope.planDefaultSettings.defaultMaxAccessLogin);
                }
                updateServices(true);
            } else
                if(newValue === 'Commercial'){
		        if(oldValue && oldValue != newValue){
                    $scope.siteUsageComponentConfig.autoPopulate = true;
                }

		        if(oldValue)
                    updateServices(false);

                if ($scope.planDefaultSettings){
                    $scope.userUsagedatamodified = new Date().getTime();
                }
            }
		}
	}, true);

    $scope.siteChange = function() {
        if ($scope.newSiteUsage.siteId != -1){
            for(var zoneKey in $scope.zoneMap) {
               	if ($scope.zoneMap[zoneKey].includes($scope.newSiteUsage.site.countryRaw)){
               	    $scope.newSiteUsage.region = zoneKey;
                   	break;
               	}
            }
            $scope.newSiteUsage.isAllocated = true;
        }
        else{
            $scope.newSiteUsage.isAllocated = false;
        }
    };

    $scope.calcExpirationTime = function (expDate) {
        if (!expDate) {
            return null;
        }

        var nowDate = new Date();
        var nowDateUTC = DateTimeService.getDateInUTC(nowDate);

        if (nowDateUTC.getDate() === expDate.getDate() && nowDateUTC.getMonth() === expDate.getMonth() && nowDateUTC.getYear() === expDate.getYear()) {
            return null;
        }
        return moment.duration(expDate.getTime() - nowDate.getTime()).humanize();
    };

    var newTimeFrame = DateTimeService.calculateTimeFrame();
    $scope.fromDate = newTimeFrame.fromDate;
    $scope.toDate = newTimeFrame.toDate;

    $scope.item = {
        loadingTimeData : true,
        loading : true
    };

    function getSiteUsageStats(){
        store.fetch({
            method: 'GET',
            path: "/getUsageData?accountId=" + $state.params.accountId,
            success: function (data) {
                if(data) {
                    populatePlan(data);
                    $scope.loadedUsage = true;
                    $scope.$digest();
                }
            }
        });
    }

    function populatePlan(siteUsageStats){
        $scope.planStats.totalStats = {};
        $scope.planStats.totalStats.total = siteUsageStats.siteTotal;
        $scope.planStats.totalStats.commercial = siteUsageStats.siteTotalCommercial;
        $scope.planStats.totalStats.trial = siteUsageStats.siteTotalTrial;
        $scope.planStats.totalStats.lock = siteUsageStats.siteTotalLock;
        $scope.planStats.totalStats.disable = siteUsageStats.siteTotal - (siteUsageStats.siteTotalCommercial + siteUsageStats.siteTotalTrial + siteUsageStats.siteTotalLock);

        $scope.planStats.usedStats = {};
        $scope.planStats.usedStats.total = siteUsageStats.siteUsedTotal;
        $scope.planStats.usedStats.commercial = siteUsageStats.siteUsedCommercial;
        $scope.planStats.usedStats.trial = siteUsageStats.siteUsedTrial;
        $scope.planStats.usedStats.lock = siteUsageStats.siteUsedLock;
        $scope.planStats.usedStats.disable = siteUsageStats.siteUsedTotal - (siteUsageStats.siteUsedCommercial + siteUsageStats.siteUsedTrial + siteUsageStats.siteUsedLock);

        $scope.planStats.unusedStats = {};
        $scope.planStats.unusedStats.total = siteUsageStats.siteUnusedTotal;
        $scope.planStats.unusedStats.commercial = siteUsageStats.siteUnusedCommercial;
        $scope.planStats.unusedStats.trial = siteUsageStats.siteUnusedTrial;
        $scope.planStats.unusedStats.lock = siteUsageStats.siteUnusedLock;
		$scope.planStats.unusedStats.disable = siteUsageStats.siteUnusedTotal - (siteUsageStats.siteUnusedCommercial + siteUsageStats.siteUnusedTrial + siteUsageStats.siteUnusedLock);

        $scope.planStats.siteConfigured = siteUsageStats.siteConfigured;
        $scope.planStats.accessLoginTotal = siteUsageStats.accessLoginTotal;
        $scope.planStats.accessLoginConfigured = siteUsageStats.accessLoginConfigured;
        $scope.planStats.accessLoginDisabled = siteUsageStats.accessLoginDisabled;
    }
}
